module.exports = __webpack_public_path__ + "static/img/rare-masterclasses.dd701a8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/main/rare-masterclasses.png
// module id = bw6U
// module chunks = 0